import Navbar from "../components/Navbar";
import Footer from "../sections/Footer";
import { Outlet } from "react-router-dom";
import { isEmbedded } from "../utils/embed";
interface LayoutProps {
  children?: React.ReactNode;
}
function Layout({ children }: LayoutProps) {
  const embedded = isEmbedded();

  // Embed mode: compact left side menu + content on the right, no footer.
  if (embedded) {
    return (
      <div className="min-h-screen flex">
        <aside className="w-36 shrink-0 border-r border-gray-100">
          <Navbar />
        </aside>
        <div className="flex-1 py-4 px-4">{children || <Outlet />}</div>
      </div>
    );
  }

  // Normal site: unchanged.
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <div className="flex-1 mt-8 py-6">{children || <Outlet />}</div>
      <Footer />
    </div>
  );
}

export default Layout;
